/**
 * Puts text on the clipboard within the click, which every browser allows, also over plain http where
 * navigator.clipboard is missing. The clipboard API only where that fails, because it can wait on a permission.
 * @returns whether the text is on the clipboard, as far as the browser says.
 */
export const copyText = (text: string): boolean => {
    const area = document.createElement('textarea');
    area.value = text;
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    let done = false;
    try {
        done = document.execCommand('copy');
    } catch {
        done = false;
    }
    area.remove();
    if (done) return true;
    if (!navigator.clipboard) return false;
    navigator.clipboard.writeText(text).catch(() => undefined);
    return true;
};
